'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _Checkbox = require('../../../../inputs/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AuthLine(props) {
  var name = props.name,
      actions = props.actions,
      spliter = props.spliter;

  return _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
      'td',
      { scope: 'row' },
      name
    ),
    actions.map(function (action) {
      return _react2.default.createElement(
        'td',
        { key: action },
        _react2.default.createElement(_Checkbox2.default, spliter(props)(action))
      );
    })
  );
}
AuthLine.propTypes = {
  name: _propTypes.string,
  actions: _propTypes.array.isRequired,
  spliter: _propTypes.func.isRequired
};

exports.default = AuthLine;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/AuthEditor/AuthBody/AuthLine/AuthLine.js
// module id = 1739
// module chunks = 0